export const numberBetween = (min, max) => {
  const diff = max - min;
  const rand = Math.floor(Math.random() * diff);
  return rand + min;
};
export const pad = (num) => {
  return String(num).padStart(15, '0');
};

export const idsByMake = {
  Apple: [357330090000000, 357330099999999],
  Blackberry: [4401136506000, 4401139290999],
  Essential: [990010040000000, 990010040039182],
  Google: [990012000000000, 990012009999999],
  HTC: [351536070000000, 351536079999999],
  Huawei: [862790030000000, 862790039999999],
  Kyocera: [357843060000000, 357843069999999],
  LG: [357844050000000, 357844059999999],
  Motorola: [359289050000000, 359289059999999],
  Nokia: [351864070000000, 351864079999999],
  Netgear: [352323060000000, 352323069999999],
  Novatel: [12798000000000, 12798009999999],
  OnePlus: [867271020000000, 867271029999999],
  Samsung: [353305090000000, 353305099999999],
  Sony: [355385050000000, 355385059999999],
  ZTE: [863727033955646, 863727033000000],
  Other: [352323060000000, 352323069999999],
  Alcatel: [15114000000000, 15114009999999],
};
